<!-- <button (click)="accessBox = !accessBox">Switch box</button> -->
<div class="section small section-image hero-image hero-container"
[style.backgroundImage]="'url('+(this.commonService?.pages?.immagineBackgroundUrl ? this.commonService?.pages?.immagineBackgroundUrl : '')+')'">

    
    <div *ngIf="this.commonService?.pages?.logo_header_destra" class="hero-card">
        <span>{{this.commonService?.pages?.title}}</span>
        <!-- <p>
            {{'index.registerQuestion' | translate}}<br>
            {{'index.alreadyRegisterQuestion' | translate}}
        </p> -->
        <div  class="button-group text-left pt-4">
            <a aria-label="accedi" class="btn btn-cstm btn-primary" [href]="this.commonService?.pages?.accedi">Accedi</a>
        </div>
    </div>
    <!-- <div class="hero-image hero-container">
        <div class="container-fluid d-flex flex-wrap align-items-start pb-lg-5 h-100"> 
            <div class="hero-text px-2 pt-4 px-sm-5 px-sm-2 pt-md-5 pb-1">
                <h1 class="hero-title">{{'index.title' | translate}}</h1>
                <p class="hero-description"> {{'index.description' | translate}} </p>
            </div>
        </div>
    </div> -->
    </div>
<div class="row wrapper-shadow p-3 d-flex justify-content-center"> 
    <div class="index-page px-4 pt-4 col-sm-12">
        <div class="row">
            <div class="col">
                <span class="info-title">{{this.commonService?.pages?.titolo_descrizione}}</span>
            </div>
        </div>
            <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12">
                   <p class="paragraph mt-4" [innerHTML]="commonService?.pages?.description"></p>
                </div>
            </div>
            <div class="imgs mt-2">
                    <div *ngFor="let img of this.commonService?.pages?.logo" class="banner">
                        <img [src]="img.url ? img.url : ''">
                    </div>
            </div>
          
</div>
